import { HttpErrorResponse } from '@angular/common/http';

import { ApiError } from './api-error.model';

interface ValidationDetail {
  readonly msg?: unknown;
}

interface ApiErrorBody {
  readonly detail?: unknown;
  readonly detail_code?: unknown;
  readonly code?: unknown;
  readonly message?: unknown;
}

export function resolveApiError(error: unknown, fallback = 'Произошла ошибка запроса.'): ApiError {
  if (!(error instanceof HttpErrorResponse)) {
    return {
      status: null,
      detail: error instanceof Error && error.message ? error.message : fallback,
      detailCode: null,
      validationMessages: [],
      originalError: error,
    };
  }

  const body = error.error as ApiErrorBody | null | undefined;
  const validationMessages = Array.isArray(body?.detail)
    ? body.detail
        .map((item: unknown) => {
          if (!item || typeof item !== 'object') {
            return null;
          }

          const validationDetail = item as ValidationDetail;
          return typeof validationDetail.msg === 'string' ? validationDetail.msg : null;
        })
        .filter((message): message is string => Boolean(message))
    : [];

  const detail =
    typeof body?.detail === 'string'
      ? body.detail
      : validationMessages.length > 0
        ? validationMessages.join(', ')
        : typeof body?.message === 'string'
          ? body.message
          : error.message || fallback;

  const detailCode =
    typeof body?.detail_code === 'string'
      ? body.detail_code
      : typeof body?.code === 'string'
        ? body.code
        : null;

  return {
    status: error.status || null,
    detail,
    detailCode,
    validationMessages,
    originalError: error,
  };
}
